import GPCHandler from './GPCHandler'

export default GPCHandler
